export const GET_TEACHER_SCHOOL_MEDIA = 'GET_TEACHER_SCHOOL_MEDIA'
export const GET_MEDIA_WISE_GALLERY = 'GET_MEDIA_WISE_GALLERY'
